import React from 'react';
import { Card } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

const VisibilityCardMeta = ({ visibility }) => (
  <Card.Meta className="text">
    <FormattedMessage id={`visibility.with.prefix.${visibility}`} />
  </Card.Meta>
);

export default VisibilityCardMeta;
